<template>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field name="name" label="token" id="id" v-model="token"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn color="success" @click="notificar">Notificar</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NotificarService from "../../services/Notificar.service"
export default {
  data() {
    return {
      token: "",
    }
  },methods: {
    notificar(){
      NotificarService.NotificarFirebase(this.token);
      
    }
  },
};

</script>
<style></style>